// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"158":"labels","472":"settings","594":"about"}[chunkId] + "." + {"158":"03391b9e","472":"e0214ecd","594":"5d1056d0"}[chunkId] + ".css";
};